module.exports = __webpack_public_path__ + "img/picture_46.db62c787.png";